import { render, staticRenderFns } from "./PlanVenues.vue?vue&type=template&id=3adbe9a5&"
import script from "./PlanVenues.vue?vue&type=script&lang=js&"
export * from "./PlanVenues.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports